import {Box} from '@mui/material';
import {Column} from '@tanstack/react-table';
import React, {useEffect} from 'react';
import {RxCaretSort, RxCaretDown, RxCaretUp} from 'react-icons/rx';
interface AppTableColumnSortingProps<TData> {
    column: Column<TData, unknown>;
    onSortChangeHandler: (sortValue: 'asc' | 'desc' | false) => void;
}

export const AppTableColumnSorting = <TData,>({column, onSortChangeHandler}: AppTableColumnSortingProps<TData>) => {
    const prevSortRef = React.useRef<string | false | undefined>(undefined);
    useEffect(() => {
        const current = column.getIsSorted();
        if (prevSortRef.current !== undefined && prevSortRef.current !== current) {
            onSortChangeHandler(current);
        }
        prevSortRef.current = current;
    }, [column.getIsSorted()]);

    const handleSort = (event: React.MouseEvent) => {
        const handler = column.getToggleSortingHandler();
        if (typeof handler === 'function') handler(event);
    };

    return (
        <>
            <Box
                component="span"
                onClick={handleSort}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mr: 0.5,
                    cursor: 'pointer',
                }}
            >
                {column.getIsSorted() ? (
                    column.getIsSorted() === 'desc' ? (
                        <RxCaretDown size={16} />
                    ) : (
                        <RxCaretUp size={16} />
                    )
                ) : (
                    <RxCaretSort size={16} />
                )}
            </Box>
        </>
    );
};

export default AppTableColumnSorting;
